import React from "react"
import {ManagedSolutionsApplication} from "../../resources/managedSolutions"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import classNames from "classnames"
import {kebabCase, startCase} from "lodash"
import moment from "moment"
import {Meta} from "../../resources/common"
import {Link, useNavigate} from "react-router-dom"

interface ManagedSolutionsApplicationsTableProps {
	applications: Array<ManagedSolutionsApplication>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	fullHeight?: boolean
	meta?: Meta
	sortBy?: string
	sortFunction?: () => void
}

export default function ManagedSolutionsApplicationsTable({
	applications,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	fullHeight,
	meta,
	sortBy,
	sortFunction,
}: ManagedSolutionsApplicationsTableProps) {
	const noContent = applications.length === 0
	const navigate = useNavigate()

	return (
		<div className={"managed-solutions-applications-table"}>
			<DataTable isEmpty={noContent} fullHeight={fullHeight} noContentText="No applications yet">
				<DataTableHead className={classNames(!fullHeight && "no-sticky")}>
					<DataTableRow>
						<DataTableCell>ID</DataTableCell>
						<DataTableCell>User IDs</DataTableCell>
						<DataTableCell>Status</DataTableCell>
						<DataTableCell>Application Form</DataTableCell>
						<DataTableCell>Customer</DataTableCell>
						<DataTableCell clickable onClick={() => sortFunction?.()} sortable sortApplied={sortBy === "createdAt"}>
							Created At
						</DataTableCell>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{applications.map((application) => {
						const status = application.attributes.status
						const createdAt = application.attributes.createdAt
						const customerId = application.relationships?.customer?.data?.id
						const applicationFormId = application.relationships?.applicationForm?.data?.id

						return (
							<DataTableRow
								key={application.id}
								onClick={(e) => {
									e.preventDefault()
									navigate(`/managed-solutions/applications/${application.id}`)
								}}
							>
								<DataTableCell className="data-table-id-cell">{application.id}</DataTableCell>
								<DataTableCell>
									{application.attributes.userIds.map((userId, index) => (
										<div key={index}>{userId}</div>
									))}
								</DataTableCell>
								<DataTableCell>
									{status ? (
										<div className={classNames("applications-status", kebabCase(status))}>{startCase(status)}</div>
									) : (
										"-"
									)}
								</DataTableCell>
								<DataTableCell>
									{applicationFormId ? (
										<Link
											className="link"
											to={`/managed-solutions/application-forms/${applicationFormId}`}
											onClick={(e) => e.stopPropagation()}
										>
											{applicationFormId}
										</Link>
									) : (
										"-"
									)}
								</DataTableCell>
								<DataTableCell>
									{customerId ? (
										<Link
											className="link"
											to={`/managed-solutions/customers/${customerId}`}
											onClick={(e) => e.stopPropagation()}
										>
											{customerId}
										</Link>
									) : (
										"-"
									)}
								</DataTableCell>
								<DataTableCell>{createdAt ? moment(createdAt).format("L LT") : "-"}</DataTableCell>
							</DataTableRow>
						)
					})}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
